import { InboundFaxSortOrderType, SortDirection } from "@/Common/Models/UI/Enums";
import { InboundFax } from "@/Documents/Models/InboundFax/InboundFax";
import { InboundFaxIndexingFormModel } from "@/Documents/Models/InboundFax/InboundFaxIndexingFormModel";
import { InboundFaxMailboxFilterSettingsModel } from "@/Documents/Models/Settings/InboundFaxMailboxFilterSettings";
import { InboundFaxView } from "@/Documents/Models/UI/InboundFaxEnums";

class InboundFaxMailboxModel {
    public searchText: string = "";
    public queryCurrentPageNumber: number = 1;
    public queryPageCount: number = 0;
    public queryRowCount: number = 0;
    public urgentFaxesCount: number = 0;
    public queryOrderType: InboundFaxSortOrderType = InboundFaxSortOrderType.DateReceived;
    public queryOrderDirection: SortDirection = SortDirection.ASC;
    public faxes: InboundFax[] = [];
    public faxesForm: { [id: string]: InboundFaxIndexingFormModel } = {};
    public triageFaxes: InboundFaxIndexingFormModel[] = [];
    public filteringSettings: InboundFaxMailboxFilterSettingsModel = new InboundFaxMailboxFilterSettingsModel();
    public currentView: InboundFaxView = InboundFaxView.FaxesList;
    public currentFax: InboundFax = null;
    public pdfViewerSelectedZoomLevelIndex: number = 5;
}

export { InboundFaxMailboxModel };
